import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import HelloWorld2 from '@/components/HelloWorld2'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: HelloWorld
    },
    {
      path: '/abc/',
      name: 'Hello2',
      component: HelloWorld2
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js